export const extractMentions = (text, employees) => {
  const mentionRegex = /@(\w+)/g;
  const mentions = [];
  let match;
  
  while ((match = mentionRegex.exec(text)) !== null) {
    const username = match[1];
    const employee = employees.find(emp => 
      emp.username?.toLowerCase() === username.toLowerCase() ||
      emp.name?.toLowerCase().includes(username.toLowerCase())
    );
    if (employee && employee.id) {
      mentions.push(employee.id);
    }
  }
  
  return mentions;
};
// ============================================================================
// MONDAY.COM STYLE CONSTANTS & UTILITIES
// ============================================================================

export const MONDAY_COLORS = {
  completed: { bg: "#00c875", hover: "#00b36b", text: "#ffffff" },
  "in-progress": { bg: "#fdab3d", hover: "#fc9b1d", text: "#ffffff" },
  pending: { bg: "#c4c4c4", hover: "#b0b0b0", text: "#ffffff" },
  "not-started": { bg: "#e2e2e2", hover: "#d0d0d0", text: "#333333" },
  stuck: { bg: "#e44258", hover: "#d23249", text: "#ffffff" },
  done: { bg: "#00c875", hover: "#00b36b", text: "#ffffff" },
  default: { bg: "#f6f7fb", hover: "#e0e0e0", text: "#333333" },
};

export const getInitials = (name) => {
  if (!name || name === "—" || name === "Unassigned") return "?";
  const parts = String(name).trim().split(" ").filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return String(name).slice(0, 2).toUpperCase();
};

export const getColorFromName = (name) => {
  if (!name || name === "—" || name === "Unassigned") return "#c4c4c4";
  const colors = ["#0073ea", "#00c875", "#9d99ff", "#ff6ac2", "#fdab3d", "#00d3d1", "#e44258", "#bb3354"];
  const hash = String(name).split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return colors[hash % colors.length];
};

// Treat the row as corporate if it has Task-shaped task_category, falling
// back to the legacy Client.is_corporate field for older callers.
export const isCorporate = (c) => (c.task_category ? c.task_category === 'corporate' : !!c.is_corporate);

// Human-readable label for a task row. Task.name is auto-generated but can be
// blank, so fall back to the client name plus whatever identifies the task.
export const taskLabel = (task) => {
  if (task?.name) return task.name;
  const parts = [task?.client_name, task?.task_type_name, task?.fiscal_year];
  const label = parts.filter(Boolean).join(" ");
  return label || "this task";
};
